var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "horizontal-month-picker" }, [
    _c("div", { staticClass: "swiper-container" }, [
      _c(
        "div",
        { staticClass: "swiper-wrapper" },
        _vm._l(_vm.dates, function(date) {
          return _c(
            "div",
            {
              staticClass: "swiper-slide",
              class: _vm.isDateActive(date) ? "active" : "",
              on: {
                click: function($event) {
                  return _vm.setPublishDate(date)
                }
              }
            },
            [_vm._v(_vm._s(date.label))]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-button-prev" }, [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "10.93",
              height: "12.621",
              viewBox: "0 0 10.93 12.621"
            }
          },
          [
            _c("path", {
              attrs: {
                d: "M-1735.9-950.024l10.93,6.31v-12.621Z",
                transform: "translate(1735.899 956.335)",
                fill: "#2d3135"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-button-next" }, [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "10.93",
              height: "12.621",
              viewBox: "0 0 10.93 12.621"
            }
          },
          [
            _c("path", {
              attrs: {
                d: "M-246.466-949.024l-10.93-6.31v12.621Z",
                transform: "translate(257.396 955.335)",
                fill: "#2d3135"
              }
            })
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }